import React, { FC } from 'react'
import LocationPinIcon from 'transfix-icons/build/LocationPinIcon'
import { Button } from 'transfix-ui/components/Button'
import { Box } from 'transfix-ui/core'
import 'scss/5_components/_date-picker.scss'

interface IUseMyLocationButtonProps {
  onClick: () => void
}

/** `Use My Location` Button, which is used by Pickup and Dropoff location filter components */
export const UseMyLocationButton: FC<IUseMyLocationButtonProps> = ({ onClick }) => {
  return (
    <Button color='tertiary' onClick={onClick} size='large' fullWidth>
      <Box display='flex' flexDirection='row' alignContent='center'>
        <LocationPinIcon size='large' />
        <Box pl={0.5}>Use my location</Box>
      </Box>
    </Button>
  )
}
